import AdminWrapper from '@/components/Avatars/AdminWrapper';
import AbstractAvatar from '@/components/Avatars/AbstractAvatar';
import { getLevelColor } from '@/utils/colors';
import { ICaseBattlePlayer } from '@/utils/types/ICaseBattlePlayer';
import { ICaseBattleGame } from '@/utils/types/ICaseBattle';

interface Props {
    player: ICaseBattlePlayer;
    gameStatus: ICaseBattleGame['status'];
}

const GameBattleAvatar = ({ player, gameStatus }: Props) => {
    const { user } = player;
    const lvl = Math.max(0, Math.floor((user?.experience ?? 0) / 100));
    const color = getLevelColor(lvl);

    return (
        <AdminWrapper
            buttons={{ battleWinner: gameStatus === 'PENDING' }}
            teamId={player.teamId}
            user={player.user}
        >
            <div className="relative w-8 h-8">
                <AbstractAvatar
                    seed={user?.name || String(player.userId)}
                    src={user?.avatar}
                    size={32}
                    square
                    className="!w-full !h-full"
                />
                <span
                    className="absolute -inset-[2px] rounded-[30%] pointer-events-none"
                    style={{ border: `1.5px solid ${color}`, boxShadow: `0 0 8px -2px ${color}` }}
                />
            </div>
        </AdminWrapper>
    );
};

export default GameBattleAvatar;
